import { SelectableCard } from "features/shared/components/SelectableCard";
import { useTranslation } from "react-i18next";
import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { TechnicalDataScenario } from "../model/types";

import { scenarioCardWidthClassName } from "../lib/scenarioCardStyles";
import { isDefaultScenario } from "../lib/scenarioDefaults";
import { ScenarioMetricItem } from "./ScenarioMetricItem";

type ScenarioCardProps = {
  isActive: boolean;
  onDelete: () => void;
  onEdit: () => void;
  onSelect: () => void;
  scenario: TechnicalDataScenario;
};

export const ScenarioCard = ({ isActive, onDelete, onEdit, onSelect, scenario }: ScenarioCardProps) => {
  const { t } = useTranslation();
  const isDefault = isDefaultScenario(scenario);

  return (
    <SelectableCard
      className={scenarioCardWidthClassName}
      isActive={isActive}
      onDelete={isDefault ? undefined : onDelete}
      onEdit={onEdit}
      onSelect={onSelect}
      showActionButtons
      title={scenario.name}
    >
      <div className="grid w-full grid-cols-1 gap-3">
        <ScenarioMetricItem
          iconName="People"
          label={t("TechnicalData.scenario.metrics.occupancy")}
          value={formatNumberBasedOnUser(scenario.occupancy)}
        />
        <ScenarioMetricItem
          iconName="Energy"
          label={t("TechnicalData.scenario.metrics.internalLoads")}
          value={formatNumberBasedOnUser(scenario.internalLoads)}
        />
        <ScenarioMetricItem
          iconName="Wrench"
          label={t("TechnicalData.scenario.metrics.heatRecoveryEfficiency")}
          value={formatNumberBasedOnUser(scenario.heatRecoveryEff)}
        />
      </div>
    </SelectableCard>
  );
};
